import { render, staticRenderFns } from "./submissions-table-row.vue?vue&type=template&id=6730129d&scoped=true&"
import script from "./submissions-table-row.vue?vue&type=script&lang=ts&"
export * from "./submissions-table-row.vue?vue&type=script&lang=ts&"
import style0 from "./submissions-table-row.vue?vue&type=style&index=0&id=6730129d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6730129d",
  null
  
)

export default component.exports